'use strict';

const Reference = require('./Reference');

module.exports = class DataReference extends Reference {
  constructor (type, ids, optional = false) {
    super();
    this.type = type;
    this.id = String(ids[0]);
    this.optional = optional;
  }

  get typeName () {
    return this.type.typeName;
  }

  storagePath (...additonalPaths) {
    return [this.typeName, 'DATA', this.id, ...additonalPaths];
  }

  asOptional () {
    return new DataReference(this.type, [this.id], true);
  }

  toString () {
    return `${this.typeName}[${this.id}]`;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/DataReference.js